"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getWindow;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// For the purposes of correctly mocking the window object in Jest,
// this is a safe way of returning it for tests to work as expected.
function getWindow() {
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === undefined) {
    throw new Error('window not available');
  }

  return window;
}